import React, { useState } from 'react';
import AccountUpdated from './your.account.is.updated';
import UpdateAccountSection from './update.account.section';

const UpdateLogin = props => {
    const [page, setPage] = useState(0);
    const {username, password, showUsername, showPassword, showSecretQuestion, showEmail, backToLogin} = props;
   
    const updateAccount =
      <UpdateAccountSection
          emailVisible={showEmail}
          passwordVisible={showPassword}
          resetLoginFlow={backToLogin}
          secretQuestionVisible={showSecretQuestion}
          showPageCallBack={(code) => setPage(code)}
          temporaryPassword={password}
          temporaryUsername={username}
          usernameVisible={showUsername}
      />;
   
    const accountUpdatedInfoSection =
      <AccountUpdated resetLoginFlow={backToLogin}/>;
   
    const pages = [updateAccount, accountUpdatedInfoSection];
   
    return pages[page];
};
export default UpdateLogin;